export const GEAR_CONTENT_TYPE_FIELD_TYPE = {
  UNDEFINED: 0,
  CONTENT_TYPE: 1,
  CONTENT_TYPE_VERSION: 2,
  STRING: 3,
  DATE: 4,
  DATETIME: 5,
  BOOL: 6,
  INT: 7,
  INT64: 8,
  DECIMAL: 9,
  CHOICE: 10,
  MULTI_CHOICE: 11
} as const;

export type GearContentTypeFieldType = (typeof GEAR_CONTENT_TYPE_FIELD_TYPE)[keyof typeof GEAR_CONTENT_TYPE_FIELD_TYPE];
